import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { downloadChangesReport } from '../../api/changesReport'
import DateRangeInput, {
    onDateChange,
} from '../Shared/DateRangeInput/DateRangeInput'

import styles from './changes-report-export.module.scss'

export default function ChangesReportExport() {
    const defaultDateFrom = new Date()
    defaultDateFrom.setMonth(defaultDateFrom.getMonth() - 1)

    const { t } = useTranslation()
    const [dateFrom, setDateFrom] = useState(defaultDateFrom.toISOString())
    const [dateTo, setDateTo] = useState('')

    const params = new URLSearchParams()

    if (dateFrom) {
        params.append('since', dateFrom)
    }
    if (dateTo) {
        params.append('until', dateTo)
    }

    return (
        <section className={styles.changesReportExport}>
            <h2 className={styles.changesReportExport__title}>
                {t('changes_report_export')}
            </h2>
            <div className={styles.changesReportExport__content}>
                <DateRangeInput
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    onDateChange={onDateChange(setDateFrom, setDateTo)}
                />
                <button
                    className={styles.changesReportExport__btn}
                    onClick={() => downloadChangesReport(params)}
                >
                    {t('download_changes_report')}
                </button>
            </div>
        </section>
    )
}
